var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgOrange = function SvgOrange(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1921,
    height: 1080,
    viewBox: "0 0 1921 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_136_19)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1080,
    transform: "translate(0.273438)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.66406,
    y: -2.40723,
    width: 1925.05,
    height: 1082.84,
    fill: "url(#paint0_linear_136_19)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_136_19)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1208.93,
    cy: 942.954,
    rx: 335.208,
    ry: 358.475,
    transform: "rotate(-28.5968 1208.93 942.954)",
    fill: "#FD8805"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_136_19)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 52.6517,
    cy: 993.227,
    rx: 335.208,
    ry: 358.475,
    transform: "rotate(-28.5968 52.6517 993.227)",
    fill: "#FF8408"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_136_19)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1823.58,
    cy: 424.694,
    rx: 359.008,
    ry: 358.475,
    transform: "rotate(0.850877 1823.58 424.694)",
    fill: "#FEB687"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_136_19)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 350.82,
    cy: 760.92,
    rx: 206.267,
    ry: 454.493,
    transform: "rotate(0.850877 350.82 760.92)",
    fill: "#FBCFBA"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_136_19)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1213.24,
    cy: 1080.44,
    rx: 242.868,
    ry: 215.914,
    transform: "rotate(0.850877 1213.24 1080.44)",
    fill: "#FC9824"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_136_19",
    x: 368.195,
    y: 89.5984,
    width: 1681.47,
    height: 1706.71,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 250,
    result: "effect1_foregroundBlur_136_19"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_136_19",
    x: -788.082,
    y: 139.871,
    width: 1681.47,
    height: 1706.71,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 250,
    result: "effect1_foregroundBlur_136_19"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_136_19",
    x: 964.57,
    y: -433.782,
    width: 1718.02,
    height: 1716.95,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 250,
    result: "effect1_foregroundBlur_136_19"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_136_19",
    x: -355.539,
    y: -193.533,
    width: 1412.71,
    height: 1908.91,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 250,
    result: "effect1_foregroundBlur_136_19"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_136_19",
    x: 470.375,
    y: 364.515,
    width: 1485.73,
    height: 1431.84,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 250,
    result: "effect1_foregroundBlur_136_19"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_136_19",
    x1: 735.15,
    y1: -2.40721,
    x2: 1199.23,
    y2: 1080.44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDDEB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.662753,
    stopColor: "#FCDABC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8303"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_136_19"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1080,
    fill: "white",
    transform: "translate(0.273438)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgOrange);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "orange.e81461f1c4bce0878368d4e5137e3430.svg";